import React from 'react';
import PropTypes from 'prop-types';

const BuildingAnalyticsZoneFlowTooltip = ({count, percent, source, target}) => (
  <div className={'BuildingAnalyticsZoneFlowCard--Tooltip'}>
    <div className={'BuildingAnalyticsZoneFlowCard--Tooltip--Row'}>
      <div className={'BuildingAnalyticsZoneFlowCard--Tooltip--Zone'}>
        <div
          className={'ColorIndicator'}
          style={{backgroundColor: source.color}}
        />
        <div className={'Label'}>{source.label}</div>
      </div>
      <i className='BuildingAnalyticsZoneFlowCard--Tooltip--FlowRepresentation fas fa-arrow-right' />
      <div className={'BuildingAnalyticsZoneFlowCard--Tooltip--Zone'}>
        <div
          className={'ColorIndicator'}
          style={{backgroundColor: target.color}}
        />
        <div className={'Label'}>{target.label}</div>
      </div>
    </div>
    {count ? (
      <div className={'BuildingAnalyticsZoneFlowCard--Tooltip--Row'}>
        {`${count} visitors`}
      </div>
    ) : null}
    {percent ? (
      <div className={'BuildingAnalyticsZoneFlowCard--Tooltip--Row'}>
        {`${percent.toFixed(1)}%`}
      </div>
    ) : null}
  </div>
);

const ZonePropType = PropTypes.shape({
  color: PropTypes.string,
  label: PropTypes.string,
}).isRequired;
BuildingAnalyticsZoneFlowTooltip.propTypes = {
  count: PropTypes.number,
  percent: PropTypes.number,
  source: ZonePropType,
  target: ZonePropType,
};

BuildingAnalyticsZoneFlowTooltip.defaultProps = {
  count: 0,
  percent: 0,
};

export default BuildingAnalyticsZoneFlowTooltip;
